import { graphql } from "./graphql";
export const EstimatesQuery = graphql(`
  query getEstimates {
    estimates {
      id
      number
      title
      createdAt
      date
      requestedAt
      requestedChanges
      total
      subtotal
      tax
      status
    }
  }
`);

export const EstimateQuery = graphql(`
  query getEstimate($estimateId: BigInt!) {
    account {
      fullName
      firstName
      lastName
      phone
      paymentMethodRequired
      hasPaymentMethod
      email
      address {
        city
        country
        state
        street1
        street2
        zip
      }
      credit
    }
    estimate(estimateId: $estimateId) {
      depositOwed
      depositRequirement
      id
      title
      status
      purchaseOrder
      date
      requestedChanges
      notes
      terms
      subtotal
      tax
      date
      title
      purchaseOrder
      paidAmount
      total
      createdAt
      updatedAt
      requestedAt
      number
      discountPercent
      discountAmount
      purchaseOrder
      media {
        url
        size
        objectId
        description
        thumb
        contentType
        uploadedAt
      }
      lineItems {
        id
        serviceId
        serviceName
        serviceDescription
        cost
        taxPercent1
        taxPercent2
        quantity
        taxPrice1
        taxPrice2
        subtotal
        subtotalWithTax
        removed
        isRecommended
        property {
          id
          name
          address {
            street1
            street2
            city
            state
            zip
          }
        }
      }
    }
  }
`);

export const EstimateHistoryQuery = graphql(`
  query getEstimateHistory($estimateId: BigInt!) {
    estimate(estimateId: $estimateId) {
      history {
        id
        userId
        user {
          id
          fullName
        }
        customer {
          id
          fullName
        }
        date
        action
        customerId
        comment
      }
    }
  }
`);

export const CompanyQuery = graphql(`
  query getCompany {
    company {
      id
      name
      phone
      mobile
      email
      phone
      www
      address {
        street1
        street2
        city
        state
        zip
        country
      }
      logo {
        url
        thumb
      }
      timezone
      settings {
        hideWrf
      }
      tier {
        name
        features {
          workRequests
        }
      }
    }
  }
`);

export const CompanySettingsQuery = graphql(`
  query getCompanySettings {
    company {
      id
      timezone
      currency
    }
  }
`);

export const EstimateCompanyQuery = graphql(`
  query getEstimateCompany {
    company {
      www
      address {
        city
        country
        state
        street1
        street2
        zip
      }
      id
      name
      logo {
        url
        thumb
      }
      phone
      mobile
      email
      timezone
      settings {
        showEstimateCostRate
        showEstimateQuantityPerHour
      }
    }
  }
`);

export const PublicCompanyQuery = graphql(`
  query getPublicCompanyInfoQuery($companyId: Int!) {
    getPublicCompanyInfo(companyId: $companyId) {
      id
      name
      phone
      mobile
      email
      phone
      www
      isBanned
      address {
        street1
        street2
        city
        state
        zip
        country
      }
      logo {
        url
        thumb
      }
      timezone
    }
  }
`);

export const StripeQuery = graphql(`
  query findOneByCompany {
    stripe {
      id
      stripeAccountId
    }
  }
`);

export const AnalyticsQuery = graphql(`
  query getCustomerInfo {
    account {
      id
      fullName
      email
    }
    company {
      id
      name
    }
  }
`);
